'use client';

import { Suspense } from 'react';
import FindWidget from './FindWidget';

function FindWidgetFallback() {
  return <div></div>;
}

export default function FindWidgetWrapper() {
  return (
    <Suspense fallback={<FindWidgetFallback />}>
      <FindWidget />
    </Suspense>
  );
}
